// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Bg_wrap_kp6_3","none":"Bg_none_26LqJ","purple":"Bg_purple_2-0sm","green":"Bg_green_29eYJ","red":"Bg_red_2NeYY","gray":"Bg_gray_X9OE0","gradation":"Bg_gradation_npyPD"};